import { evaluateFeature } from './evaluator';
import {
  getFeature,
  getOverrideValue,
  listFeatures,
  listFeaturesByCategory,
  mergeFeatureOverrides,
  parseFeatureOverride,
  resolveEnvironmentOverrides,
} from './evaluation-helpers';
import { FeatureEvaluationOptions } from './evaluation.types';
import { FEATURE_REGISTRY, assertFeatureRegistered } from './registry';
import { FeatureKey } from './types';

export type { FeatureEvaluationOptions } from './evaluation.types';

export {
  getFeature,
  getOverrideValue,
  listFeatures,
  listFeaturesByCategory,
  mergeFeatureOverrides,
  parseFeatureOverride,
  resolveEnvironmentOverrides,
};
export { getFeatureEnvVarName } from './evaluation-helpers';

export function isFeatureEnabled(
  key: FeatureKey,
  options: FeatureEvaluationOptions = {},
): boolean {
  return evaluateFeature(key, options).enabled;
}

export function buildFeatureStateMap(
  options: FeatureEvaluationOptions = {},
): Readonly<Record<FeatureKey, boolean>> {
  const registry = options.registry ?? FEATURE_REGISTRY;

  return Object.values(FeatureKey).reduce<Record<FeatureKey, boolean>>(
    (stateMap, key) => {
      assertFeatureRegistered(key);
      stateMap[key] = isFeatureEnabled(key, {
        registry,
        overrides: options.overrides,
        evaluationContext: options.evaluationContext,
      });
      return stateMap;
    },
    {} as Record<FeatureKey, boolean>,
  );
}
